import { Injectable } from '@angular/core';
import {Product} from "../model/Product";
import {Type} from "../model/Type";
import {Photo} from "../model/Photo";
import {Http, Response} from "@angular/http";
import { Headers, RequestOptions } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import {AuthenticationService} from "./authentication.service";
import {environment} from "../../environments/environment";

@Injectable()
export class PhotoService {

    photosUrl = environment.instantPaiementApi + "photos";

    constructor(private http: Http,
                private authenticationService: AuthenticationService) {}

    getPhoto(id: number): Promise<Photo> {
        return this.http.get(this.photosUrl + "/" + id)
            .toPromise()
            .then(response => response.json() as Product)
            .then(undefined, (error) => { console.error(error); })
            .catch(this.handleError);
        //return Promise.resolve(this.product);
    }

    getListPhotos(): Promise<Photo[]> {
        return this.http.get(this.photosUrl)
            .toPromise()
            .then(response => response.json() as Product[])
            .then(undefined, (error) => { console.error(error); })
            .catch(this.handleError);
    }

    removePhoto(idPhoto:number): Promise<Photo> {
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.authenticationService.getToken() });
        let options = new RequestOptions({ headers: headers });
        return this.http.delete(environment.instantPaiementApi + "/uploadMyImage.php?delete=" + idPhoto, options).toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    private extractData(res: Response) {
        let body = res.json();
        return body.data || { };
    }

    handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }

}


// WEBPACK FOOTER //
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/app/services/photo.service.ts